import script from "./SportingActivitiesManually.vue?vue&type=script&setup=true&lang=js"
export * from "./SportingActivitiesManually.vue?vue&type=script&setup=true&lang=js"

import "./SportingActivitiesManually.vue?vue&type=style&index=0&id=7fc06a3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc06a3a"]])

export default __exports__